import { GenericResponse } from 'services/api/base';
import { WBSequentialMapData } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getMapData';
import { WBSequentialMapsOptions, WBSequentialMapsOptionsResponse } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getOptions';

export function transformGetOptionsResponse(
  response: WBSequentialMapsOptionsResponse,
): WBSequentialMapsOptions {
  const { data } = response;
  const variables = data.variaveis.map((variable) => ({
    value: variable.var,
    label: variable.label,
    order: variable.order,
    hidden: variable.hidden,
    unit: variable.unit,
    period: variable.period,
    config: variable.config,
  }));

  return {
    variables,
    startDate: data.periodos_de_analise.data_inicial,
    endDate: data.periodos_de_analise.data_final,
    maxInterval: data.periodos_de_analise.intervalo_maximo,
  };
}

export function transformMapDataResponse(
  response: GenericResponse<WBSequentialMapData>,
): WBSequentialMapData {
  return response.data.map(([lat, lon, v]) => [lat, lon, v]);
}
